import React from 'react';
import Image from '../Image';
import { Link } from '../Link';
import './BlogPost.scss';

export const BlogPost = props => {
  const { image, title, excerpt, content } = props;
  return (
    <section className="blog-post">
      <div className="wrapper">
        <header className="blog-post-header">
          <div className="blog-post-content-wrapper">
            <h1 className="blog-post-title" dangerouslySetInnerHTML={{ __html: title && title.text }} />
            <div className="blog-post-meta">
              <Link className="blog-post-back-link" to="/blog/">
                Back to blog
              </Link>
              {/* {date && <span className="blog-post-date">Posted {new Date(date).toLocaleDateString('en-AU')}</span>} */}
            </div>
          </div>
        </header>
        <div className="blog-post-image">
          <Image image={image} alt={title && title.text} />
        </div>
        <div className="blog-post-content">
          {excerpt && excerpt.html && (
            <div
              className="blog-post-content-wrapper blog-post-excerpt"
              dangerouslySetInnerHTML={{ __html: excerpt.html }}
            />
          )}
          <div className="blog-post-content-wrapper" dangerouslySetInnerHTML={{ __html: content.html }} />
        </div>
      </div>
    </section>
  );
};
